module.exports = __webpack_public_path__ + "images/d86f59f513c54ad5ed0acec63a8f2cf1.gif";